import { render, staticRenderFns } from "./agendaDialog.vue?vue&type=template&id=66f790ee&scoped=true"
import script from "./agendaDialog.vue?vue&type=script&lang=js"
export * from "./agendaDialog.vue?vue&type=script&lang=js"
import style0 from "./agendaDialog.vue?vue&type=style&index=0&id=66f790ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f790ee",
  null
  
)

export default component.exports